// assets/product-dual-atc.js
(function(){
    function addToCart(variantId, qty, productForm){
      // NEW FEATURE: If member mode is active, check if we're trying to add a Non-Member variant
      // and if so, switch to the Member variant instead
      var isMemberMode = window.MemberMode && window.MemberMode.get();
      
      if (isMemberMode && productForm) {
        // Try to find if this is a Non-Member variant and get the Member variant instead
        var correctedVariantId = findCorrectVariantId(productForm, 'Member', variantId);
        if (correctedVariantId && correctedVariantId !== variantId) {
          variantId = correctedVariantId;
        }
      }
      
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type':'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty || 1 })
      }).then(function(r){
        if (!r.ok) {
          return r.json().catch(function(){ return {}; }).then(function(body){
            var err = new Error(body.description || body.message || 'Failed to add to cart');
            err.soldOut = /sold out|unavailable|stock/i.test((body.description || '') + ' ' + (body.message || ''));
            throw err;
          });
        }
        return r.json();
      });
    }

    // Shared button feedback: spinner while an add is in flight, and an inline
    // message instead of alert() when it fails.
    function setButtonLoading(btn, on){
      btn.classList.toggle('loading', on);
      btn.disabled = on;
      var spinner = btn.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.toggle('hidden', !on);
    }

    function flashButtonError(btn, err){
      var message = err && err.soldOut ? 'Sold out' : 'Try again';
      var label = btn.querySelector('.main-atc__label__text');
      if (label) {
        var original = label.textContent;
        label.textContent = message;
        setTimeout(function(){ label.textContent = original; }, 2500);
      } else {
        var original = btn.innerHTML;
        btn.textContent = message;
        setTimeout(function(){ btn.innerHTML = original; }, 2500);
      }
    }
  
    function updateCartUsingThemeMethod() {
      
      return new Promise(function(resolve, reject) {
        const cartDrawer = document.querySelector('cart-drawer');
        const cartDrawerItems = document.querySelector('cart-drawer-items');
        
        // Check if cart was empty before adding item
        const wasEmpty = cartDrawer && cartDrawer.classList.contains('is-empty');
        
        if (cartDrawerItems && typeof cartDrawerItems.updateCart === 'function') {
          try {
            // If cart was empty, we need to force remove empty state first
            if (wasEmpty) {
              cartDrawer.classList.remove('is-empty');
              cartDrawerItems.classList.remove('is-empty');
            }
            
            cartDrawerItems.updateCart();
            
            // Double-check empty state is removed after update
            setTimeout(function() {
              if (cartDrawer.classList.contains('is-empty')) {
                cartDrawer.classList.remove('is-empty');
                cartDrawerItems.classList.remove('is-empty');
              }
            }, 100);
            
            resolve();
          } catch (error) {
            console.error('updateCart method failed:', error);
            reject(error);
          }
        } else {
          // Simple fallback: just reload the page
          window.location.reload();
        }
      });
    }
  
    function openCartDrawer(){
      // The cart drawer is about to open; a still-open quick-add modal underneath it
      // is just a second popup, so close it first.
      document.querySelectorAll('quick-add-modal[open]').forEach(function(modal){
        if (typeof modal.hide === 'function') {
          modal.hide(true);
        } else {
          modal.removeAttribute('open');
        }
      });

      const cartDrawer = document.querySelector('cart-drawer');
      
      if (cartDrawer) {
        
        // Try the theme's open method first
        if (typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          cartDrawer.classList.add('active');
        }
      }
      
      // Trigger cart update events
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
      document.dispatchEvent(new CustomEvent('cartQuantityUpdated'));
    }
  
    // Set up listeners to keep the visible price matched to the selected variant.
    function setupVariantChangeListeners() {
      updateVariantPriceDisplay();

      document.querySelectorAll('variant-selects input, variant-selects select').forEach(function(input) {
        if (input.dataset.variantPriceListenerBound === 'true') return;
        input.dataset.variantPriceListenerBound = 'true';
        input.addEventListener('change', function() {
          setTimeout(function() {
            updateVariantPriceDisplay();
            updatePricingDisplay();
          }, 0);
        });
      });

      document.addEventListener('variant:change', function() {
        setTimeout(function() {
          updateVariantPriceDisplay();
          updatePricingDisplay();
        }, 0);
      });
    }
    
    // Helper function to find the correct variant based on membership type and selected options  
    function findCorrectVariantId(productForm, membershipType, currentVariantId) {
      if (!productForm) return currentVariantId;
      
      // Try to get product variants from JSON script tag or window object
      var productVariants = null;
      
      // Look inside this product's own form first, so a quick add modal doesn't read
      // the variants of the product page behind it
      var variantScript = productForm.querySelector('script[data-product-variants]') ||
                          productForm.querySelector('script[type="application/json"]') ||
                          document.querySelector('script[data-product-variants]');
      if (variantScript) {
        try {
          productVariants = JSON.parse(variantScript.textContent);
        } catch(e) {}
      }

      // Fallback: check if pagefly exposed product data
      if (!productVariants && window.__pageflyProducts) {
        var productId = productForm.dataset.productId || productForm.querySelector('[data-product-id]')?.dataset.productId;
        if (productId && window.__pageflyProducts[productId]) {
          productVariants = window.__pageflyProducts[productId].variants;
        }
      }
      
      if (!productVariants || productVariants.length === 0) {
        return currentVariantId;
      }
      
      // Get the currently selected options (excluding Membership)
      var selectedOptions = [];
      var allInputs = productForm.querySelectorAll('input[type="radio"]:checked, select');
      
      allInputs.forEach(function(input) {
        var optionName = input.getAttribute('name');
        if (optionName && optionName !== 'id' && optionName !== 'quantity' && optionName !== 'Membership') {
          selectedOptions.push(input.value);
        }
      });
      
      // If no options found via checked inputs, parse current variant to extract size/options
      if (selectedOptions.length === 0 && currentVariantId) {
        var currentVariant = productVariants.find(function(v) {
          return v.id.toString() === currentVariantId.toString();
        });
        
        if (currentVariant) {
          [currentVariant.option1, currentVariant.option2, currentVariant.option3].forEach(function(opt) {
            if (opt && opt !== 'Member' && opt !== 'Non-Member') {
              selectedOptions.push(opt);
            }
          });
        }
      }
      
      // Find the variant that matches the membership type AND all selected options
      var matchingVariant = productVariants.find(function(variant) {
        var hasMembership = variant.option1 === membershipType || 
                            variant.option2 === membershipType || 
                            variant.option3 === membershipType;
        
        if (!hasMembership) return false;
        
        var hasAllSelectedOptions = selectedOptions.every(function(optValue) {
          return variant.option1 === optValue || 
                 variant.option2 === optValue || 
                 variant.option3 === optValue;
        });
        
        return hasMembership && hasAllSelectedOptions;
      });
      
      return matchingVariant ? matchingVariant.id.toString() : currentVariantId;
    }

    function getProductVariants(productForm) {
      var variantScript = null;

      if (productForm) {
        var variantSelects = document.querySelector('variant-selects[data-section="' + productForm.dataset.section + '"]');
        variantScript = variantSelects ? variantSelects.querySelector('script[type="application/json"]') : null;
        if (!variantScript) {
          variantScript = productForm.querySelector('script[type="application/json"]');
        }
      }

      if (!variantScript) {
        variantScript = document.querySelector('variant-selects script[type="application/json"]');
      }

      if (!variantScript) return [];

      try {
        return JSON.parse(variantScript.textContent) || [];
      } catch(e) {
        console.error('Could not parse product variants for price update:', e);
        return [];
      }
    }

    function getSelectedOptionValues(productForm) {
      var selectedOptions = [];
      var scope = productForm || document;
      var optionInputs = scope.querySelectorAll('input[type="radio"]:checked, select');

      if (!optionInputs.length) {
        optionInputs = document.querySelectorAll('variant-selects input[type="radio"]:checked, variant-selects select');
      }

      optionInputs.forEach(function(input) {
        var optionName = input.getAttribute('name') || '';
        optionName = optionName.replace(/^options\[(.*)\]$/, '$1');
        if (!optionName || optionName === 'id' || optionName === 'quantity' || optionName === 'Membership') return;
        selectedOptions.push(input.value);
      });

      return selectedOptions;
    }

    function hasMembership(variant, membershipType) {
      return variant.option1 === membershipType || variant.option2 === membershipType || variant.option3 === membershipType;
    }

    function findVariantForMembership(productVariants, membershipType, selectedOptions, fallbackVariant) {
      var matchingVariant = productVariants.find(function(variant) {
        if (!hasMembership(variant, membershipType)) return false;
        return selectedOptions.every(function(optValue) {
          return variant.option1 === optValue || variant.option2 === optValue || variant.option3 === optValue;
        });
      });

      if (matchingVariant) return matchingVariant;
      if (fallbackVariant && hasMembership(fallbackVariant, membershipType)) return fallbackVariant;

      return productVariants.find(function(variant) {
        return hasMembership(variant, membershipType);
      }) || null;
    }

    function formatVariantMoney(cents) {
      if (cents == null || isNaN(cents)) return '';

      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents);
      }

      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
      }).format(cents / 100);
    }

    // Fill the offer copy tokens rendered by snippets/offer-price-tokens.liquid and hide
    // a block when one of its tokens has no sensible value (same rules as the snippet).
    function updateOfferTokens(scope, todayPrice, comparePrice) {
      var hasSaving = comparePrice > todayPrice;
      var values = {
        price: todayPrice > 0 ? formatVariantMoney(todayPrice) : null,
        compare_price: hasSaving ? formatVariantMoney(comparePrice) : null,
        amount_saved: hasSaving ? formatVariantMoney(comparePrice - todayPrice) : null,
        percentage_saved: hasSaving ? Math.floor(((comparePrice - todayPrice) * 100) / comparePrice) + '%' : null
      };

      scope.querySelectorAll('[data-offer-block]').forEach(function(block) {
        var invalid = false;
        block.querySelectorAll('[data-offer-token]').forEach(function(el) {
          var value = values[el.dataset.offerToken];
          if (value == null) invalid = true;
          el.textContent = value || '';
          el.toggleAttribute('data-offer-invalid', value == null);
        });
        block.classList.toggle('hidden', invalid);
      });
    }

    function updateVariantPriceDisplay() {
      var productForm = document.querySelector('product-form form') || document.querySelector('form[action*="/cart/add"]');
      var productVariants = getProductVariants(productForm);
      if (!productVariants.length) return;

      var variantInput = productForm ? productForm.querySelector('input[name="id"]') : document.querySelector('input[name="id"]');
      var currentVariantId = variantInput ? variantInput.value : null;
      var currentVariant = productVariants.find(function(variant) {
        return currentVariantId && variant.id.toString() === currentVariantId.toString();
      }) || productVariants.find(function(variant) { return variant.available !== false; }) || productVariants[0];

      if (!currentVariant) return;

      var selectedOptions = getSelectedOptionValues(productForm);
      if (!selectedOptions.length) {
        [currentVariant.option1, currentVariant.option2, currentVariant.option3].forEach(function(opt) {
          if (opt && opt !== 'Member' && opt !== 'Non-Member') selectedOptions.push(opt);
        });
      }

      var nonMemberVariant = findVariantForMembership(productVariants, 'Non-Member', selectedOptions, currentVariant);
      var memberVariant = findVariantForMembership(productVariants, 'Member', selectedOptions, currentVariant);
      var compareAtPrice = (nonMemberVariant && nonMemberVariant.compare_at_price) || (memberVariant && memberVariant.compare_at_price) || currentVariant.compare_at_price;

      // Offer copy follows the chosen options, not the id input: that can still hold the
      // previous variant, or be the cart drawer upsell's, when this runs.
      var optionVariant = productVariants.find(function(variant) {
        return selectedOptions.every(function(optValue) {
          return variant.option1 === optValue || variant.option2 === optValue || variant.option3 === optValue;
        });
      }) || currentVariant;
      var hasMemberPair = !!(memberVariant && nonMemberVariant);
      updateOfferTokens(
        document.querySelector('variant-selects')?.closest('.shopify-section') || document,
        hasMemberPair ? memberVariant.price : optionVariant.price,
        hasMemberPair ? compareAtPrice : optionVariant.compare_at_price
      );

      document.querySelectorAll('.product-page-price .price--member-enabled').forEach(function(priceBlock) {
        if (nonMemberVariant) {
          priceBlock.querySelectorAll('.price-item--non-member, .price-item--sale-non-member').forEach(function(el) {
            el.textContent = formatVariantMoney(nonMemberVariant.price);
          });
        }

        if (memberVariant) {
          priceBlock.querySelectorAll('.price-item--member, .price-item--sale-member').forEach(function(el) {
            el.textContent = formatVariantMoney(memberVariant.price);
          });
        }

        priceBlock.querySelectorAll('.price__compare-price .price-item--regular, .main-comapre-price').forEach(function(el) {
          if (compareAtPrice) {
            el.textContent = formatVariantMoney(compareAtPrice);
            el.closest('.price__compare-price')?.classList.remove('hidden');
          }
        });

        // Base the "Save X%" badge on the member (VIP) price that is actually displayed.
        var badgeVariant = memberVariant || nonMemberVariant;
        if (compareAtPrice && badgeVariant && compareAtPrice > badgeVariant.price) {
          var percentageSaved = Math.floor(((compareAtPrice - badgeVariant.price) * 100) / compareAtPrice);
          var moneySaved = formatVariantMoney(compareAtPrice - badgeVariant.price).replace(/\.00$/, '');
          priceBlock.querySelectorAll('.badge__percentage-saved').forEach(function(el) { el.textContent = percentageSaved; });
          priceBlock.querySelectorAll('.badge__money-saved').forEach(function(el) { el.textContent = moneySaved; });
        }
      });

      // Keep the VIP purchase section (heading + dual button prices) matched to the selected variant.
      if (nonMemberVariant) {
        document.querySelectorAll('.member-offer--price').forEach(function(el) {
          el.textContent = formatVariantMoney(nonMemberVariant.price);
        });
        document.querySelectorAll('.add-to-cart-nonmember .dual-atc-price-amount').forEach(function(el) {
          el.textContent = formatVariantMoney(nonMemberVariant.price);
        });
      }
      if (memberVariant) {
        document.querySelectorAll('.add-to-cart-member .dual-atc-price-amount, .add-to-cart-member-single .dual-atc-price-amount').forEach(function(el) {
          el.textContent = formatVariantMoney(memberVariant.price);
        });
      }

      // Pair sync: both modes sell the same physical item, so if either side of the
      // selected size's Member/Non-Member pair is out of stock, both buttons show
      // sold out. Also tells the back-in-stock form which variant to watch.
      var pairSoldOut;
      if (memberVariant && nonMemberVariant) {
        pairSoldOut = memberVariant.available === false || nonMemberVariant.available === false;
      } else {
        pairSoldOut = currentVariant.available === false;
      }

      document.querySelectorAll('.add-to-cart-member, .add-to-cart-nonmember, .add-to-cart-member-single').forEach(function(btn) {
        if (pairSoldOut) {
          btn.setAttribute('data-soldout', 'true');
          btn.disabled = true;
        } else {
          btn.removeAttribute('data-soldout');
          // Re-enable; updatePricingDisplay() below re-disables the non-member
          // button when member mode is active.
          btn.disabled = false;
        }
      });
      // Sold out hides the whole buy-button stack; the rescue box below is the
      // only call to action.
      document.querySelectorAll('.pricing-block, .member-mode-single-button').forEach(function(el) {
        if (pairSoldOut) {
          el.setAttribute('data-oos-hidden', '');
        } else {
          el.removeAttribute('data-oos-hidden');
        }
      });
      if (!pairSoldOut) {
        // Re-apply member-mode rules now that the sold-out lock is lifted.
        updatePricingDisplay();
      }

      document.dispatchEvent(new CustomEvent('pair-availability:change', {
        detail: {
          soldOut: pairSoldOut,
          variantId: currentVariant.id,
          memberVariantId: memberVariant ? memberVariant.id : null,
          nonMemberVariantId: nonMemberVariant ? nonMemberVariant.id : null
        }
      }));
    }
  
    function updatePricingDisplay() {
      // Check localStorage first (especially important on cart page for immediate application)
      let isMemberMode = false;
      let isFreeTeeMode = false;
      
      try {
        const memberModeValue = localStorage.getItem('member_mode') === 'true';
        const freeTeeModeValue = localStorage.getItem('freetee_mode') === 'true';
        
        isMemberMode = memberModeValue || 
                       document.body.classList.contains('member-mode') || 
                       (window.MemberMode && window.MemberMode.get());
        isFreeTeeMode = freeTeeModeValue || 
                        document.body.classList.contains('freetee-mode') || 
                        (window.MemberMode && window.MemberMode.getFreeTeeMode());
        
        // FreeTee mode overrides member mode - customers must pay non-member price
        if (isFreeTeeMode) {
          isMemberMode = false;
        }
      } catch(e) {
        isMemberMode = document.body.classList.contains('member-mode') || 
                       (window.MemberMode && window.MemberMode.get());
        isFreeTeeMode = document.body.classList.contains('freetee-mode') || 
                        (window.MemberMode && window.MemberMode.getFreeTeeMode());
        if (isFreeTeeMode) {
          isMemberMode = false;
        }
      }
      
      // Update all non-member buttons based on member mode.
      // Never re-enable a button whose variant pair is sold out (data-soldout).
      document.querySelectorAll('.add-to-cart-nonmember').forEach(function(btn) {
        if (isMemberMode) {
          btn.disabled = true;
        } else {
          btn.disabled = btn.hasAttribute('data-soldout');
        }
      });
      
      // Update pricing blocks
      document.querySelectorAll('.pricing-block').forEach(function(block) {
        if (isMemberMode) {
          block.classList.add('member-mode-active');
        } else {
          block.classList.remove('member-mode-active');
        }
      });
      
      // Hide/show member offer based on freetee mode
      document.querySelectorAll('.member-offer').forEach(function(offer) {
        if (isFreeTeeMode) {
          offer.style.display = 'none';
        } else {
          // Show member offer when NOT in freetee mode
          offer.style.setProperty('display', 'block', 'important');
          offer.style.setProperty('visibility', 'visible', 'important');
          offer.style.setProperty('opacity', '1', 'important');
          offer.style.setProperty('max-height', 'none', 'important');
        }
      });
      
      // Update single member button visibility (never while the pair is sold
      // out — data-oos-hidden hides the whole stack)
      document.querySelectorAll('.member-mode-single-button').forEach(function(btn) {
        if (isMemberMode && !isFreeTeeMode && !btn.hasAttribute('data-oos-hidden')) {
          btn.style.display = 'block';
        } else {
          btn.style.display = 'none';
        }
      });
      
      // Apply direct inline styles for all pages (same approach that works on product pages)
      // Remove any existing inline styles first
      document.querySelectorAll('.price-item--member, .price-item--sale-member, .price-item--non-member, .price-item--sale-non-member').forEach(function(el) {
        el.style.removeProperty('display');
        el.style.removeProperty('visibility');
        el.style.removeProperty('opacity');
      });
      
      // Then apply appropriate styles based on current mode
      if (!isMemberMode && !isFreeTeeMode) {
        // Force non-member prices when not in any special mode
        document.querySelectorAll('.price-item--member, .price-item--sale-member').forEach(function(el) {
          el.style.setProperty('display', 'none', 'important');
          el.style.setProperty('visibility', 'hidden', 'important');
          el.style.setProperty('opacity', '0', 'important');
        });
        
        document.querySelectorAll('.price-item--non-member, .price-item--sale-non-member').forEach(function(el) {
          el.style.setProperty('display', 'inline', 'important');
          el.style.setProperty('visibility', 'visible', 'important');
          el.style.setProperty('opacity', '1', 'important');
        });
      } else {
        // Force member prices when in member mode
        document.querySelectorAll('.price-item--non-member, .price-item--sale-non-member').forEach(function(el) {
          el.style.setProperty('display', 'none', 'important');
          el.style.setProperty('visibility', 'hidden', 'important');
          el.style.setProperty('opacity', '0', 'important');
        });
        
        document.querySelectorAll('.price-item--member, .price-item--sale-member').forEach(function(el) {
          el.style.setProperty('display', 'inline', 'important');
          el.style.setProperty('visibility', 'visible', 'important');
          el.style.setProperty('opacity', '1', 'important');
        });
      }

      // The MAIN product price element always shows the MEMBER price, regardless of mode.
      // Runs last so it overrides the non-member forcing above.
      document.querySelectorAll('.main-price.price-item--non-member, .main-price.price-item--sale-non-member').forEach(function(el) {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('opacity', '0', 'important');
      });
      document.querySelectorAll('.main-price.price-item--member, .main-price.price-item--sale-member').forEach(function(el) {
        el.style.setProperty('display', 'inline', 'important');
        el.style.setProperty('visibility', 'visible', 'important');
        el.style.setProperty('opacity', '1', 'important');
      });

      // Collection / listing cards always show the MEMBER price, regardless of mode.
      document.querySelectorAll('.price--card-member .price-item--non-member, .price--card-member .price-item--sale-non-member').forEach(function(el) {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('opacity', '0', 'important');
      });
      document.querySelectorAll('.price--card-member .price-item--member, .price--card-member .price-item--sale-member').forEach(function(el) {
        el.style.setProperty('display', 'inline', 'important');
        el.style.setProperty('visibility', 'visible', 'important');
        el.style.setProperty('opacity', '1', 'important');
      });
    }

    // Make updatePricingDisplay globally available for cart change events
    window.updatePricingDisplay = updatePricingDisplay;
    
    // Force pricing update by directly checking cart
    function forceUpdatePricingFromCart() {
      if (window.MemberMode && window.MemberMode.refreshFromServer) {
        // Add delay to ensure server has processed cart changes before we check
        setTimeout(function() {
          window.MemberMode.refreshFromServer().then(function() {
            updatePricingDisplay();
          }).catch(function(error) {
            console.error('Failed to refresh member mode:', error);
            updatePricingDisplay();
          });
        }, 300);
      } else {
        updatePricingDisplay();
      }
    }
    
    window.forceUpdatePricingFromCart = forceUpdatePricingFromCart;
  
    // Buttons can be rendered after init (quick add modal), so they are matched by
    // delegation instead of being bound directly.
    var DUAL_BUTTONS = [
      { selector: '.add-to-cart-member-single', membership: 'Member', addedLabel: 'Added!' },
      { selector: '.add-to-cart-nonmember', membership: 'Non-Member', addedLabel: 'Added!' },
      { selector: '.add-to-cart-member', membership: 'Member', addedLabel: 'Added to VIP!' }
    ];

    function handleDualButtonClick(e){
      if (!e.target || typeof e.target.closest !== 'function') return;

      var btn = null;
      var config = null;

      for (var i = 0; i < DUAL_BUTTONS.length; i++) {
        btn = e.target.closest(DUAL_BUTTONS[i].selector);
        if (btn) {
          config = DUAL_BUTTONS[i];
          break;
        }
      }

      if (!btn) return;

      e.preventDefault();

      // Get the currently selected variant from the product form
      var productForm = btn.closest('product-form') || btn.closest('form');
      var selectedVariantInput = productForm ? productForm.querySelector('input[name="id"]') : null;
      var currentVariantId = selectedVariantInput ? selectedVariantInput.value : null;

      // For products with Member/Non-Member variants, find the variant that matches
      // the currently selected size/options
      var id = findCorrectVariantId(productForm, config.membership, currentVariantId);

      // Fallback to button's data attribute if variant finding fails
      if (!id) {
        id = btn.getAttribute('data-variant-id');
      }

      if (!id) {
        console.error('No variant ID found');
        return;
      }

      // Snapshot BEFORE the loading state so the restored markup has the
      // spinner hidden.
      var originalHTML = btn.innerHTML;

      setButtonLoading(btn, true);

      // Get quantity from the quantity input field
      var quantityInput = productForm ? productForm.querySelector('input[name="quantity"], #Quantity-' + productForm.dataset.section) : null;
      var quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

      addToCart(id, quantity, productForm).then(function(result){
        updateCartUsingThemeMethod().then(function(){
          openCartDrawer();
          setTimeout(forceUpdatePricingFromCart, 200);

          // Pair-choice tiles keep their structure (name/price/CTA spans); the modal
          // closes on success anyway, so an "Added!" text swap just makes them flicker.
          if (!btn.classList.contains('member-pair-choice__option')) {
            btn.textContent = config.addedLabel;
            setTimeout(function(){
              // Restore the full markup (price span, sold-out span, spinner) —
              // a textContent swap here destroyed it for the rest of the view.
              btn.innerHTML = originalHTML;
              var spinner = btn.querySelector('.loading-overlay__spinner');
              if (spinner) spinner.classList.add('hidden');
            }, 2000);
          }
        }).catch(function(error){
          console.error('Cart update failed:', error);
        });
      }).catch(function(error){
        console.error('Failed to add to cart:', error);
        flashButtonError(btn, error);
      }).finally(function(){
        setButtonLoading(btn, false);
      });
    }

    function bindDualButtons(){
      updatePricingDisplay();
      setupVariantChangeListeners();

      // Same named handler every time, so re-running init cannot double-bind.
      document.addEventListener('click', handleDualButtonClick);
    }
  
    // Member/Non-Member pair cards render a modal-opener so guests can choose a mode,
    // but in member mode that choice is already made: intercept in the capture phase
    // (before modal-opener's own listener) and one-click add the Member variant.
    function handleMemberPairQuickAdd(e){
      if (!e.target || typeof e.target.closest !== 'function') return;
      var btn = e.target.closest('[data-member-pair]');
      if (!btn || btn.disabled) return;

      var isMember = document.body.classList.contains('member-mode') ||
                     (window.MemberMode && window.MemberMode.get());
      if (!isMember) return; // guest: let the options modal open

      var id = btn.getAttribute('data-variant-member-id');
      if (!id) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      setButtonLoading(btn, true);

      addToCart(id, 1, null).then(function(){
        updateCartUsingThemeMethod().then(function(){
          openCartDrawer();
          setTimeout(forceUpdatePricingFromCart, 200);
        }).catch(function(error){
          console.error('Cart update failed:', error);
        });
      }).catch(function(error){
        console.error('Failed to add member variant via quick-add:', error);
        flashButtonError(btn, error);
      }).finally(function(){
        setButtonLoading(btn, false);
      });
    }

    function bindMemberPairQuickAdd(){
      // Named handler + capture flag: re-running init cannot double-bind.
      document.addEventListener('click', handleMemberPairQuickAdd, true);
    }

    function bindQuickAddButtons(){
      document.addEventListener('click', function(e){
        var btn = e.target.closest('.card-quick-add');
        if (!btn) return;
        
        // Prevent default form submission
        e.preventDefault();
        e.stopPropagation();
  
        var isMember = document.body.classList.contains('member-mode') || 
                       (window.MemberMode && window.MemberMode.get());
        var id = isMember ? 
                 btn.getAttribute('data-variant-member-id') : 
                 btn.getAttribute('data-variant-nonmember-id');
  
        // Fallback: if no member/non-member variant data attributes, get variant from form
        if (!id) {
          var productForm = btn.closest('product-form') || btn.closest('form');
          if (productForm) {
            var variantInput = productForm.querySelector('input[name="id"]');
            if (variantInput) {
              id = variantInput.value;
            }
          }
        }
  
        if (!id) {
          console.error('Quick add: No variant ID found for button', btn);
          return;
        }
  
        setButtonLoading(btn, true);
        
        // For quick-add buttons, always use quantity 1 since they don't have a quantity selector
        // Note: Quick-add buttons already handle member/non-member selection above
        addToCart(id, 1, null).then(function(result){
          updateCartUsingThemeMethod().then(function(){
            openCartDrawer();
            setTimeout(forceUpdatePricingFromCart, 200);
          }).catch(function(error){
            console.error('Cart update failed:', error);
          });
        }).catch(function(error){
          console.error('Failed to add via quick-add:', error);
          flashButtonError(btn, error);
        }).finally(function(){
          setButtonLoading(btn, false);
        });
      });
    }
  
    function setupCartChangeDetection() {
      let updateInProgress = false;
      let debounceTimer = null;
      
      function debouncedUpdate() {
        if (updateInProgress) return;
        
        if (debounceTimer) {
          clearTimeout(debounceTimer);
        }
        
        debounceTimer = setTimeout(function() {
          updateInProgress = true;
          forceUpdatePricingFromCart();
          
          setTimeout(function() {
            updateInProgress = false;
          }, 1000);
        }, 500);
      }
      
      // Watch for changes to the cart drawer content
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        const observer = new MutationObserver(function(mutations) {
          const hasContentChange = mutations.some(function(mutation) {
            return mutation.type === 'childList' && mutation.addedNodes.length > 0;
          });
          
          if (hasContentChange) {
            debouncedUpdate();
          }
        });
      
        observer.observe(cartDrawer, {
          childList: true,
          subtree: true
        });
      }
      
      // Listen for cart events
      document.addEventListener('cart:refresh', debouncedUpdate);
      document.addEventListener('cart:updated', debouncedUpdate);
      document.addEventListener('cartQuantityUpdated', debouncedUpdate);
      
      // Listen for member mode changes (from collection navigation)
      document.addEventListener('memberModeChanged', function(e) {
        updatePricingDisplay();
      });
      
      // Update pricing when cart drawer closes
      document.addEventListener('click', function(e) {
        if (e.target.closest('.drawer__close') || e.target.closest('[data-close-drawer]')) {
          setTimeout(updatePricingDisplay, 500);
        }
      });
      
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          setTimeout(updatePricingDisplay, 500);
        }
      });
    }
  
    var initialized = false;
    
    function init(){
      if (initialized) return;
      initialized = true;
      
      bindDualButtons();
      bindMemberPairQuickAdd();
      bindQuickAddButtons();
      setupCartChangeDetection();
    }
  
    if (document.readyState !== 'loading') {
      init();
    } else {
      document.addEventListener('DOMContentLoaded', init);
    }
  
    // Re-bind when sections are loaded in theme editor
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function(){
        initialized = false;
        init();
      });
    }
    
    // Delayed initialization for late-loading elements
    setTimeout(init, 1000);
  })();